import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  width: 100%;
  background-color: white;
  padding: 10px;
`

const TopLevel = styled.div`
  min-width: 300px;
  max-width: 750px;
  width: 100%;
  height: 350px;
`

const Card = styled.div`
  width: 100%;
  height: 100%;
  padding: 25px 0;
  // border-top: 1px solid lightgrey;
`


export const ScorecardList = ({ data }) => {

  return (
    <div
      style={{display: 'flex', justifyContent: 'center'}}
    >
      <TopLevel>
          <StyledContainer>
            <Card>
              <h1 style={{textAlign: 'center', margin: 0, padding: 0}}>{data.date}</h1>
            </Card>
            {data.scores.map(entry => {
              const teamA = entry[0]
              const teamB = entry[1]

              return (
                <Card key={teamA.name}>
                </Card>
              )
            })}
          </StyledContainer>
      </TopLevel>
    </div>
  )
}

export const ScoreCard = ({ game, score, details, isCancelled }) => {

  const { homeTeam, awayTeam } = game

  const { homeTeamRuns, awayTeamRuns } = score || {}

  return (
    <Card style={{padding: '10px 0', position: 'relative'}}>
      {isCancelled &&
        <div
          style={{position: 'absolute', width: '100%', height: '100%'}}
        >
          <h1
            style={{textAlign: 'center'}}
          >
            <strong
              style={{fontSize: '4rem', opacity: '0.25'}}
            >CANCELLED</strong>
          </h1>
        </div>
      }
      <div style={{marginBottom: '10px'}}>
        <SingleTeamScore_
          showDetailed={false}
          team={homeTeam}
          runs={homeTeamRuns ?? '-'}
          record={details?.homeTeamRecord}
          winner={homeTeamRuns > awayTeamRuns}
        />
      </div>
      <div style={{borderTop: '1px solid lightgrey'}}>
        <SingleTeamScore_
          showDetailed={false}
          team={awayTeam}
          runs={awayTeamRuns ?? '-'}
          record={details?.awayTeamRecord}
          winner={awayTeamRuns > homeTeamRuns}
          bottom={true}
        />
      </div>
    </Card>
  )
}

export const SingleTeamScore_ = ({team, runs, record, bottom = false, winner = false, showDetailed = true}) => {
  const { name, totalPoints, pointsGained } = team

  return (
    <div
      style={{display: 'flex', justifyContent: 'space-between', padding: '0 10px', marginTop: bottom ? '10px' : undefined}}
    >
      <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
        <TeamNameView detailedView={showDetailed} winner={winner}>{name}</TeamNameView>
        <RecordView>{record}</RecordView>

        {showDetailed &&
          <RecordView>{record} &nbsp;&nbsp; {totalPoints} points (+{pointsGained})</RecordView>
        }
      </div>

      <div style={{width: '10px'}} />

      <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', paddingRight: '10px'}}>
        <ScoreView winner={winner}>{runs}</ScoreView>
      </div>
    </div>
  )
}

const ScoreView = styled.h1`
  margin: 0;
  padding: 0;
  
  color: ${props => props.winner ? 'black' : 'grey'};

  font-size: 2.4rem;
  
  @media (min-width: 800px) {
    font-size: 2.6rem;
  }
`

const TeamNameView = styled.h4`
  margin: 0;
  padding: 0;
  
  color: ${props => props.winner ? 'black' : 'grey'};
  
  font-size: 1.2rem;
  
  @media (min-width: 800px) {
    font-size: 1.3rem;
  }
`

const RecordView = styled.h4`
  margin: 0;
  padding: 0;
  text-align: left;
  
  color: grey;
  font-size: 1.1rem;
  
  @media (min-width: 800px) {
    font-size: 1.2rem;
  }
`
